module.exports = __webpack_public_path__ + "static/media/AdamMaldonadoJr.074b587a.jpg";